






























































































import { Component, Prop } from 'nuxt-property-decorator';
import IAElementComponent from './IAElementComponent.vue';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'TrueFalse'
})
export default class TrueFalse extends IAElementComponent {
  @Prop({ type: Object, default: () => [] })
  template!: IaElementsInterface;

  get correct(): string {
    return this.labels.positive;
  }

  get incorrect(): string {
    return this.labels.negative;
  }

  removeAnswers(): void {
    this.answers = [];
    this.isValidated = false;
    this.$refs.inputField.forEach((elm) => {
      elm.lazyValue = '';
    });
  }
}
